import React, { useCallback, useEffect, useRef, useState } from 'react';
import { screeningClearanceRuleApi } from '../../apis';
import { useParams } from 'react-router';

import './ScreeningClearanceRules.scss';
import { InternalApiScreeningClearanceRuleWithAllContents, InternalApiEntityType } from '../../api-internal';
import ScreeningClearanceRuleContents from './contents/ScreeningClearanceRuleContents';
import ScreeningClearanceRuleInfo from './ScreeningClearanceRuleInfo';
import { formatEnumLabel } from '../../common/helper';
import SalvPage from '../../common/SalvPage';

export function ScreeningClearanceRule() {
  const params = useParams<{
    handle: string;
    entity: string;
  }>();
  const handle = params.handle!;
  const entity = params.entity!;

  const [editing, setEditing] = useState(!handle);
  const isMounted = useRef(false);

  const [rule, setRule] = useState<InternalApiScreeningClearanceRuleWithAllContents>();
  const entityType =
    entity?.toUpperCase() === InternalApiEntityType.PERSON
      ? InternalApiEntityType.PERSON
      : InternalApiEntityType.TRANSACTION;

  const updateRule = (newRule: InternalApiScreeningClearanceRuleWithAllContents) => {
    setEditing(false);
    setRule(newRule);
  };

  const fetchRule = useCallback(async () => {
    const rule = await screeningClearanceRuleApi.getRule({
      handle,
    });
    if (isMounted.current) {
      setRule(rule);
    }
  }, [handle]);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (handle) {
      fetchRule();
    } else {
      setRule({
        reason: '',
        details: '',
        screeningType: entityType,
        enabled: false,
      });
    }
  }, [handle, entityType, fetchRule]);

  return (
    <SalvPage
      title={
        rule
          ? rule.handle
            ? `${formatEnumLabel(rule.screeningType)} clearance rule`
            : `Add ${rule.screeningType.toLowerCase()} clearance rule`
          : undefined
      }
    >
      {rule && (
        <ScreeningClearanceRuleInfo rule={rule} editing={editing} updateRule={updateRule} setEditing={setEditing} />
      )}
      {rule?.contents && rule?.handle && (
        <ScreeningClearanceRuleContents
          ruleHandle={rule.handle}
          entityType={rule.screeningType}
          fetchRule={fetchRule}
          contents={rule.contents}
        />
      )}
    </SalvPage>
  );
}

export default ScreeningClearanceRule;
